// extracted by mini-css-extract-plugin
module.exports = {"followMe":"j4","linkItem":"j5","linkItemWrap":"j6","title":"j7","linkAppItemWrap":"j8","iconWrap":"j9","mfollowMe":"j-","miconWrap":"j_","followMe-dark":"ka","followMeDark":"ka"};